import { observer } from 'mobx-react-lite';
import { getUserRoleNames } from '../../models/User';
import { departmentStore } from '../../stores/DepartmentStore';
import { userStore } from '../../stores/UserStore';

const Home = () => {
	const roles = getUserRoleNames(userStore.currentUser);
	const isActive = userStore.currentUser?.isActive;
	const hasDepartmentAccess = Boolean(departmentStore.activeDepartment);
	const isAccessLoading = userStore.isLoading || departmentStore.isLoading;
	const showAccessMessages = !isAccessLoading;
	const showDepartmentAccessMessage = showAccessMessages && isActive && roles.length > 0 && !hasDepartmentAccess;

	return (
		<div className='center-content'>
			<h4 className='welcome'>Welcome to Quick Finances!</h4>
			{showAccessMessages && (isActive && roles.length > 0 && hasDepartmentAccess ? null : (
				<>
					{!isActive && <p>Your account is set to inactive. Contact the administrator for assistance.</p>}
					{isActive && roles.length === 0 &&
						<p>
							It does not look like you have any roles assigned at this time.<br />
							If you need to see parts of this application, please contact the administrator for appropriate access.
						</p>}
					{showDepartmentAccessMessage &&
						<p>
							It does not look like you have access to this department website.<br />
							If you need access here, please contact the administrator.
						</p>}
				</>
			))}
		</div>
	);
};

export default observer(Home);